'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isProdEnv = process.env.NODE_ENV === 'production';

exports.isProdEnv = isProdEnv;
//# sourceMappingURL=isProdEnv.js.map
